import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export const AddNewButton = ({
  resource,
  className,
  match,
  readOnly,
  ...props
}) =>
  readOnly ? null : (
    <Link
      className={classNames('btn btn-success', className)}
      to={`${match.url}/new`}
      {...props}
    >
      <span className="fa fa-plus mr-1" />Add New {resource}
    </Link>
  );

export default AddNewButton;



// WEBPACK FOOTER //
// ./src/components/common/Tables/AddNewButton.jsx